import React, { useState, useRef } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';
import TeamAddMembersModal from 'team/shared/features/addMember/TeamAddMembersModal';
import { useAuth } from 'contexts/AuthContext';
import TeamWhiteButtonWithIcon from 'team/shared/components/button/TeamWhiteButtonWithIcon';

const TeamTopMenu = ({ onAddMembersClick }) => {
    const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
    const addButtonRef = useRef(null);
    const { authState } = useAuth();

    // Get user data from auth state (simple pattern like InsightsMenu.js)
    const userName = authState?.user?.fullName || 'User';

    // Get current time for greeting
    const getCurrentGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good morning';
        if (hour < 17) return 'Good afternoon';
        return 'Good evening';
    };

    const greeting = getCurrentGreeting();

    const handleAddMemberModalOpen = (event) => {
        addButtonRef.current = event.currentTarget;
        setIsAddMemberModalOpen(true);
    };

    const handleAddMemberModalClose = () => {
        setIsAddMemberModalOpen(false);
    };

    const handleAddMemberSelect = (option) => {
        setIsAddMemberModalOpen(false);
        if (onAddMembersClick) {
            onAddMembersClick(option);
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            minWidth: 0, // Allow shrinking
            padding: '24px 24px 16px 32px',
            boxSizing: 'border-box'
        }}>
            {/* Left side - Greeting only */}
            <Box sx={{
                flex: '0 1 auto',
                minWidth: 0,
                overflow: 'hidden'
            }}>
                <Typography
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '20px',
                        fontWeight: 500,
                        color: '#000',
                        margin: 0,
                        lineHeight: '28.6px',
                        WebkitFontSmoothing: 'antialiased',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {greeting}, {userName}
                </Typography>
            </Box>

            {/* Right side - Add Members button */}
            <Box sx={{
                flex: '0 0 auto',
                flexShrink: 0,
                marginRight: '24px'
            }}>
                <TeamWhiteButtonWithIcon
                    ref={addButtonRef}
                    icon={AddIcon}
                    text="Add Members"
                    onClick={handleAddMemberModalOpen}
                    padding="6px 16px"
                    iconProps={{ fontSize: '16px' }}
                    sx={{
                        minWidth: '140px',
                        fontSize: '0.875rem',
                        fontWeight: 400,
                        '&:hover': {
                            backgroundColor: '#f5f5f5',
                            borderColor: '#d0d0d0',
                            boxShadow: 'none',
                        },
                    }}
                />
            </Box>

            {/* Add Members Modal */}
            <TeamAddMembersModal
                isOpen={isAddMemberModalOpen}
                onClose={handleAddMemberModalClose}
                onSelect={handleAddMemberSelect}
                anchorEl={addButtonRef.current}
            />
        </Box>
    );
};

export default TeamTopMenu;
